export default {
    name: 'RecallReviewDetails',
}